const initialState = {
    value: 'corporate'
}

export const selectedCategoryUserReducer = (state = initialState, actions) => {
    if (actions.type === 'SET_CATEGORY_USER') {
        return {
            ...state,
            value: actions.category
        }
    }
    return state
}